<script setup>
//region Imports
import { ref, onMounted, reactive, watch } from 'vue'
import StepHeader from '../components/StepHeader.vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))

const readIssue = () => JSON.parse(localStorage.getItem('tc-claim-issue'))

const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const clickToContinue = () => {
  location.replace('#/claim/compensation')
}

const clickToBack = () => {
  location.replace('#/claim/start')
}

const clickToCancel = () => {
  if (!confirm('Are you sure?')) {
    return
  }

  location.replace('#/order')
}
//endregion
//region Variables
const data = reactive(readData() ?? {})
const issue = reactive(readIssue() ?? {})
const orderNumber = ref(data?.orderNumber ?? '')
const items = reactive(readSelectedItems() ?? [])
//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
  }
})

watch(issue, () => {
  localStorage.setItem('tc-claim-issue', JSON.stringify(issue))
}, { deep: true })
//endregion
</script>

<template>

<!--
<figure class="w-full h-[305px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">&nbsp;</figure>
-->

  <div class="px-[20px] my-[30px] lg:px-[40px]">

    <step-header :data="data" :items="items"/>

    <main class="lg:max-w-[420px] lg:text-center mx-auto">

      <div class="flex flex-row items-center mb-[20px]">
        <button type="button" @click="clickToBack">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M8 7L2 13L8 19" stroke="black" stroke-width="1.5"/>
          </svg>
        </button>
        <h1 class="text-tc-subtitle font-bold font-minionpro tracking-wider text-tc-black" v-text="`Lost Details`"></h1>
      </div>

      <textarea v-model="issue.customerNotes"
                class="bg-tc-off-white w-full h-48 border-0 placeholder-tc-creme p-[15px]"
                placeholder="What happened to your package?"></textarea>

      <div class="w-full my-[30px] flex flex-row justify-between">
        <button type="button"
            @click="clickToCancel"
            class="text-tc-xl text-black tracking-wider font-normal font-avenir py-2.5 px-8 border-b border-tc-creme"
        >Cancel
        </button>
        <button type="button"
            @click="clickToContinue"
            class="text-tc-xl text-black tracking-wider font-normal font-avenir py-2.5 px-8 border border-tc-creme"
        >Next
        </button>
      </div>

    </main>

  </div>

</template>

<style scoped>
</style>